"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preferences_1 = require("@pbl/pbl-react-core/lib/models/preferences");
var lodash_1 = __importDefault(require("lodash"));
var profile_1 = require("../../../config/profile");
var action_type_util_1 = require("../../action-type.util");
var INITIAL_STATE = {
    all: false,
    fetching: false,
    categories: [],
    tempState: {
        all: false,
        categories: []
    }
};
var valueTrue = {
    id: 1,
    displayName: 'on',
    extName: 1
};
var valueFalse = {
    id: 2,
    displayName: 'off',
    extName: 0
};
var toggle = function (collection, key) {
    return lodash_1.default.map(collection, function (category) {
        if (category.key === key) {
            return setValue(category, !category.booleanValue);
        }
        if (!lodash_1.default.isEmpty(category.subCategories)) {
            category.subCategories = lodash_1.default.map(category.subCategories, function (c) {
                if (c.key === key) {
                    c.booleanValue = !c.booleanValue;
                    if (!c.options || c.options.length === 0) {
                        c.value = c.booleanValue ? valueTrue : valueFalse;
                    }
                }
                return c;
            });
            category.booleanValue = checkAll(category.subCategories);
            if (!category.options || category.options.length === 0) {
                category.value = category.booleanValue ? valueTrue : valueFalse;
            }
        }
        return category;
    });
};
var setValue = function (category, newValue) {
    if (!lodash_1.default.isEmpty(category.subCategories)) {
        category.subCategories = lodash_1.default.map(category.subCategories, function (c) {
            var _a;
            var isDropdown = c.options !== undefined && (c === null || c === void 0 ? void 0 : c.options.length) === 0;
            if (isDropdown) {
                c.booleanValue = newValue;
            }
            var valueAlways = {
                id: 1,
                displayName: (0, profile_1.getDisplayNameForCategory)(c.key, true) || 'Always',
                extName: 1
            };
            var valueNoAlertSelected = {
                id: 0,
                displayName: (0, profile_1.getDisplayNameForCategory)(c.key, false) || 'No Alert Selected',
                extName: 0
            };
            (_a = c.options) === null || _a === void 0 ? void 0 : _a.forEach(function (t) {
                if (t.displayName === valueAlways.displayName && t.extName === valueAlways.extName) {
                    valueAlways.id = t.id;
                    return;
                }
                else if (t.displayName === valueNoAlertSelected.displayName &&
                    t.extName === valueNoAlertSelected.extName) {
                    valueNoAlertSelected.id = t.id;
                    return;
                }
            });
            if (isDropdown) {
                c.value = c.booleanValue
                    ? c.options && c.options.length > 0
                        ? valueAlways
                        : valueTrue
                    : c.options && c.options.length > 0
                        ? valueNoAlertSelected
                        : valueFalse;
            }
            return c;
        });
    }
    if (!category.options || !category.options.length) {
        category.value = newValue ? valueTrue : valueFalse;
    }
    var booleanValue = newValue;
    return __assign(__assign({}, category), { booleanValue: booleanValue });
};
var mapToBoolean = function (value) {
    if (value.displayName &&
        (value.displayName === preferences_1.ON_VALUE_DISPLAY_NAME || value.displayName === preferences_1.ALWAYS_VALUE_DISPLAY_NAME)) {
        return true;
    }
    return !(value.displayName &&
        (value.displayName === preferences_1.OFF_VALUE_DISPLAY_NAME ||
            value.displayName === preferences_1.NO_ALERT_SELECTED_VALUE_DISPLAY_NAME));
};
var mapTogglesToBoolean = function (collection) {
    return lodash_1.default.map(collection, function (category) {
        category.booleanValue = mapToBoolean(category.value);
        if (!lodash_1.default.isEmpty(category.subCategories)) {
            category.subCategories = lodash_1.default.map(category.subCategories, function (c) {
                c.booleanValue = mapToBoolean(c.value);
                return c;
            });
        }
        return category;
    });
};
var checkAll = function (collection) {
    if (lodash_1.default.isEmpty(collection)) {
        return false;
    }
    var counts = lodash_1.default.countBy(collection, function (_a) {
        var booleanValue = _a.booleanValue;
        return "".concat(booleanValue);
    });
    return !!counts['true'] && counts['true'] === collection.length;
};
exports.default = (function (state, action) {
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case (0, action_type_util_1.REQUEST)(preferences_1.PREFERENCES_FETCH):
        case (0, action_type_util_1.REQUEST)(preferences_1.PREFERENCES_FETCH_OPTIONS):
        case (0, action_type_util_1.REQUEST)(preferences_1.PREFERENCES_SAVE):
            return __assign(__assign({}, state), { fetching: true });
        case (0, action_type_util_1.SUCCESS)(preferences_1.PREFERENCES_FETCH):
            var prefs = mapTogglesToBoolean(action.payload);
            return __assign(__assign({}, state), { all: checkAll(prefs), categories: prefs });
        case preferences_1.PREFERENCES_LOAD:
            return __assign(__assign({}, state), { tempState: {
                    all: checkAll(action.payload),
                    categories: action.payload
                } });
        case preferences_1.PREFERENCES_TOGGLE_ALL:
            return __assign(__assign({}, state), { tempState: {
                    all: !state.tempState.all,
                    categories: lodash_1.default.map(state.tempState.categories, function (c) { return setValue(c, !state.tempState.all); })
                } });
        case preferences_1.PREFERENCES_TOGGLE:
            var categories = toggle(state.tempState.categories, action.payload);
            return __assign(__assign({}, state), { tempState: {
                    categories: categories,
                    all: checkAll(categories)
                } });
        case preferences_1.PREFERENCES_UPDATE_SUB_CATEGORY: {
            if (!state.tempState)
                return __assign({}, state);
            var tempCategories = lodash_1.default.map(state.tempState.categories, function (c) {
                if (c.key === action.payload.key) {
                    return __assign(__assign({}, c), action.payload);
                }
                return c;
            });
            return __assign(__assign({}, state), { tempState: {
                    categories: tempCategories,
                    all: checkAll(state.tempState.categories)
                } });
        }
        case (0, action_type_util_1.SUCCESS)(preferences_1.PREFERENCES_FETCH_OPTIONS):
            return __assign(__assign({}, state), { options: action.payload, fetching: false });
        case (0, action_type_util_1.SUCCESS)(preferences_1.PREFERENCES_SAVE):
            return __assign(__assign({}, state), { all: state.tempState.all, categories: lodash_1.default.cloneDeep(state.tempState.categories), fetching: false });
        case preferences_1.PREFERENCES_RESET:
            return __assign({}, INITIAL_STATE);
        case (0, action_type_util_1.FAILURE)(preferences_1.PREFERENCES_FETCH):
        case (0, action_type_util_1.FAILURE)(preferences_1.PREFERENCES_FETCH_OPTIONS):
        case (0, action_type_util_1.FAILURE)(preferences_1.PREFERENCES_SAVE):
            return __assign(__assign({}, state), { error: action.payload.error, fetching: false });
        default:
            return state;
    }
});
//# sourceMappingURL=reducers.js.map